import { useState } from 'react'
import { PROJECTION_CHECKIN_OPTIONS } from '../../lib/projectionCheckin'

const orderedOptions = [...PROJECTION_CHECKIN_OPTIONS].sort((a, b) => a.score - b.score)

export default function ProjectionCheckin({ value, onChange, disabled = false, micro = false }) {
  const [selectedValue, setSelectedValue] = useState(null)
  const currentValue = value !== undefined ? value : selectedValue
  return (
    <fieldset data-projection-checkin>
      <legend className="text-sm font-semibold text-cream">{micro ? 'Projection now' : 'How is this fragrance projecting at this moment?'}</legend>
      {!micro && <p className="mt-1 text-[11px] leading-relaxed text-cream/40">Choose the closest current read. Your check-in time is saved automatically.</p>}
      <div className={`${micro ? 'mt-1' : 'mt-3'} grid grid-cols-5 gap-1.5`}>
        {orderedOptions.map(option => (
          <div key={option.value} className="min-w-0 text-center" data-projection-score={option.score}>
            <button
              type="button"
              disabled={disabled}
              aria-label={`${option.score} ${option.label}: ${option.description}`}
              aria-pressed={currentValue === option.value}
              onClick={() => { setSelectedValue(option.value); onChange(option.value) }}
              className={`flex min-h-11 w-full items-center justify-center break-words rounded-xl border px-1.5 py-2 text-xs font-semibold leading-tight transition-colors disabled:cursor-not-allowed disabled:opacity-45 ${currentValue === option.value ? 'border-gold bg-gold/10 text-gold' : 'border-white/10 text-cream/65'}`}
            >
              {option.compactLabel}
            </button>
          </div>
        ))}
      </div>
      {currentValue && <p className={micro ? 'sr-only' : 'mt-2 text-[11px] leading-snug text-cream/65'} role={micro ? undefined : 'status'}>{orderedOptions.find(option => option.value === currentValue)?.description}</p>}
    </fieldset>
  )
}
